import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { LoginToken, reqData } from "../../../js/server";
import { fnNotAdmin, cloneObj } from "../../../js/util";
import { useHistory } from "react-router-dom";
import queryString from "query-string";
import SubMenu from "../../comm/SubMenu";
import SubBanner from "../../comm/SubBanner";
import UserCard from "./UserCard";

//다음 PostCode 모듈 추가
import Postcode from "@actbase/react-daum-postcode";
import { Modal } from "react-bootstrap";

function MemberView({ match, location, history }) {
    const dispatch = useDispatch();
    const usehistory = useHistory();
    const query = queryString.parse(location.search);
    const comcode = query.comcode;
    const keyword = query.keyword;
    const page = query.page;
    const [isModal, setModal] = useState(false); //daum postcode 관련 state
    const [userToken, setUserToken] = useState(null);
    const [shopinfo, setShopinfo] = useState({
        comcode: null,
        comname: null,
        boss: null,
        comidno: null,
        tel0: null,
        tel1: null,
        tel2: null,
        fax0: null,
        fax1: null,
        fax2: null,
        address1: null,
        address2: null,
        zipcode: null,
        area: null,
        comgrade: null,
        luse: null,
        registday: null,
        update_dt: null,
    });
    const [users, setUsers] = useState([]);

    const shopHandleChange = (e) => {
        const dataType = e.target.dataset["type"];
        //숫자타입인데 문자가 들어오는 경우 false
        let isState = true;
        if (dataType === "int") {
            if (isNaN(e.target.value)) {
                isState = false;
            }
        }

        if (isState) {
            let copiedObj = cloneObj(shopinfo);
            copiedObj[e.target.name] = e.target.value;
            setShopinfo(copiedObj);
        }
    };

    //우편번호 Modal 닫기
    const handleClose = () => setModal(false);

    //업체정보 저장
    const fnShopSaveClick = () => {
        const jsonData = {
            servicename: "ShopSave",
            userToken: userToken,
            jsonData: shopinfo,
        };

        dispatch({ type: "loadingChange", payload: true });
        reqData(jsonData)
            .then((res) => {
                if (res.data.result === "OK") {
                    alert("저장되었습니다.");
                } else {
                    alert(res.data.msg);
                }
            })
            .catch((err) => {
                console.error(err);
            })
            .finally(() => {
                dispatch({ type: "loadingChange", payload: false });
            });
    };

    //업체정보 삭제
    const fnShopDeleteClick = () => {
        if (
            window.confirm(
                "업체 삭제시 등록된 회원정보도 함께 삭제가 되며\n복구가 불가능합니다.\n\n삭제 하시겠습니까?"
            )
        ) {
            const jsonData = {
                servicename: "ShopDelete",
                userToken: userToken,
                comcode: comcode,
            };

            dispatch({ type: "loadingChange", payload: true });
            reqData(jsonData)
                .then((res) => {
                    if (res.data.result === "OK") {
                        alert("삭제되었습니다.");
                        usehistory.push(
                            `/Admin/MemberList?page=${page}&keyword=${encodeURI(keyword)}`
                        );
                    } else {
                        alert(res.data.msg);
                    }
                })
                .catch((err) => {
                    console.error(err);
                })
                .finally(() => {
                    dispatch({ type: "loadingChange", payload: false });
                });
        }
    };

    //사용자정보 저장
    const fnUserSaveClick = (idx, e) => {
        const jsonData = {
            servicename: "MemberSave",
            userToken: userToken,
            jsonData: users[idx],
        };

        dispatch({ type: "loadingChange", payload: true });
        reqData(jsonData)
            .then((res) => {
                if (res.data.result === "OK") {
                    alert("저장되었습니다.");
                } else {
                    alert(res.data.msg);
                }
            })
            .catch((err) => {
                console.error(err);
            })
            .finally(() => {
                dispatch({ type: "loadingChange", payload: false });
            });
    };

    //사용자정보 삭제
    const fnUserDeleteClick = (idx, e) => {
        if (
            window.confirm(`[${users[idx].userid}] 회원정보를 삭제 하시겠습니까?`)
        ) {
            const jsonData = {
                servicename: "MemberDelete",
                userToken: userToken,
                userid: users[idx].userid,
            };

            dispatch({ type: "loadingChange", payload: true });
            reqData(jsonData)
                .then((res) => {
                    if (res.data.result === "OK") {
                        alert("삭제되었습니다.");

                        let copiedObj = cloneObj(users);
                        copiedObj.splice(idx, 1);
                        setUsers(copiedObj);
                    } else {
                        alert(res.data.msg);
                    }
                })
                .catch((err) => {
                    console.error(err);
                })
                .finally(() => {
                    dispatch({ type: "loadingChange", payload: false });
                });
        }
    };

    const fnShopData = () => {
        const jsonData = {
            servicename: "ShopView",
            userToken: userToken,
            comcode: comcode,
        };

        dispatch({ type: "loadingChange", payload: true });
        reqData(jsonData)
            .then((res) => {
                if (res.data.result === "OK") {
                    setShopinfo(res.data.jsonData);
                    setUsers(res.data.jsonUser);
                } else {
                    alert(res.data.msg);
                }
            })
            .catch((err) => {
                console.error(err);
            })
            .finally(() => {
                dispatch({ type: "loadingChange", payload: false });
            });
    };

    useEffect(
        () => {
            dispatch({
                type: "pageChange",
                payload: { sub01: "관리자메뉴", sub02: "회원관리" },
            });
            dispatch({ type: "loadingChange", payload: true });

            setTimeout(() => {
                //로그인 체크
                const userinfo = JSON.parse(localStorage.getItem("userinfo"));
                if (userinfo) {
                    const userToken = userinfo.userToken;
                    setUserToken(userToken);

                    //로그인 체크 후 Usertype 검사
                    LoginToken(userToken)
                        .then((res) => {
                            if (res.data.result === "OK") {
                                if (res.data.jsonData.usertype === "0") {
                                    fnShopData();
                                } else {
                                    fnNotAdmin();
                                }
                            }
                        })
                        .catch((err) => {
                            console.error(err);
                            localStorage.removeItem("userinfo");

                            fnNotAdmin();
                        })
                        .finally(() => {
                            //dispatch({ type: 'loadingChange', payload: false })
                        });
                } else {
                    fnNotAdmin();
                }
            }, 500);
        },
        // eslint-disable-next-line
        []
    );

    return (
        <>
            <SubBanner id="admin" />

            <section className="admin section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-9">
                            <div className="row">
                                <div className="col-12">
                                    <h2>회원관리</h2>
                                    <span>조합원 및 회원 관리가 가능합니다.</span>
                                </div>
                            </div>

                            <div className="row pb-10 pt-20">
                                <div className="col-12">
                                    <button
                                        className="btn btn-light btn-custom-sm"
                                        type="button"
                                        onClick={() =>
                                            usehistory.push(
                                                `/Admin/MemberList?page=${page}&keyword=${encodeURI(
                                                    keyword
                                                )}`
                                            )
                                        }
                                    >
                                        <i className="icofont-list"></i>&nbsp;목록
                                    </button>
                                </div>
                            </div>

                            <div className="container pb-20">
                                <div className="row round-box">
                                    <div className="col-12">
                                        <div className="row">
                                            <div className="col-12 mb-30">
                                                <h5 className="sub-title">업체정보</h5>
                                            </div>

                                            <div className="col-lg-4 col-md-4 col-sm-12">
                                                <div className="form-group">
                                                    <label className="form-control-label">업체명</label>
                                                    <input
                                                        name="comname"
                                                        type="text"
                                                        className="form-control"
                                                        maxLength="25"
                                                        value={shopinfo.comname || ""}
                                                        onChange={shopHandleChange}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-lg-4 col-md-4 col-sm-12">
                                                <div className="form-group">
                                                    <label className="form-control-label">대표자명</label>
                                                    <input
                                                        name="boss"
                                                        type="text"
                                                        className="form-control"
                                                        maxLength="5"
                                                        value={shopinfo.boss || ""}
                                                        onChange={shopHandleChange}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-lg-4 col-md-4 col-sm-12">
                                                <div className="form-group">
                                                    <label className="form-control-label">
                                                        사업자등록번호
                                                    </label>
                                                    <input
                                                        name="comidno"
                                                        type="text"
                                                        className="form-control"
                                                        maxLength="10"
                                                        value={shopinfo.comidno || ""}
                                                        onChange={shopHandleChange}
                                                        data-type="int"
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-lg-4 col-md-4 col-sm-12">
                                                <div className="form-group">
                                                    <label className="form-control-label">대표전화</label>
                                                    <div className="input-group">
                                                        <input
                                                            name="tel0"
                                                            type="text"
                                                            className="form-control"
                                                            maxLength="3"
                                                            value={shopinfo.tel0 || ""}
                                                            onChange={shopHandleChange}
                                                            data-type="int"
                                                        />
                                                        <input
                                                            name="tel1"
                                                            type="text"
                                                            className="form-control"
                                                            maxLength="4"
                                                            value={shopinfo.tel1 || ""}
                                                            onChange={shopHandleChange}
                                                            data-type="int"
                                                        />
                                                        <input
                                                            name="tel2"
                                                            type="text"
                                                            className="form-control"
                                                            maxLength="4"
                                                            value={shopinfo.tel2 || ""}
                                                            onChange={shopHandleChange}
                                                            data-type="int"
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-lg-4 col-md-4 col-sm-12">
                                                <div className="form-group">
                                                    <label className="form-control-label">팩스</label>
                                                    <div className="input-group">
                                                        <input
                                                            name="fax0"
                                                            type="text"
                                                            className="form-control"
                                                            maxLength="4"
                                                            value={shopinfo.fax0 || ""}
                                                            onChange={shopHandleChange}
                                                            data-type="int"
                                                        />
                                                        <input
                                                            name="fax1"
                                                            type="text"
                                                            className="form-control"
                                                            maxLength="4"
                                                            value={shopinfo.fax1 || ""}
                                                            onChange={shopHandleChange}
                                                            data-type="int"
                                                        />
                                                        <input
                                                            name="fax2"
                                                            type="text"
                                                            className="form-control"
                                                            maxLength="4"
                                                            value={shopinfo.fax2 || ""}
                                                            onChange={shopHandleChange}
                                                            data-type="int"
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-lg-4 col-md-4 col-sm-12">
                                                <div className="form-group">
                                                    <label className="form-control-label">지역선택</label>
                                                    <select
                                                        className="custom-select"
                                                        name="area"
                                                        value={shopinfo.area || ""}
                                                        onChange={shopHandleChange}
                                                    >
                                                        <option value="">선택</option>
                                                        <option value="춘천">춘천</option>
                                                        <option value="원주">원주</option>
                                                        <option value="강릉">강릉</option>
                                                        <option value="동해">동해</option>
                                                        <option value="태백">태백</option>
                                                        <option value="속초">속초</option>
                                                        <option value="삼척">삼척</option>
                                                        <option value="홍천">홍천</option>
                                                        <option value="횡성">횡성</option>
                                                        <option value="영월">영월</option>
                                                        <option value="평창">평창</option>
                                                        <option value="정선">정선</option>
                                                        <option value="철원">철원</option>
                                                        <option value="화천">화천</option>
                                                        <option value="양구">양구</option>
                                                        <option value="인제">인제</option>
                                                        <option value="고성">고성</option>
                                                        <option value="양양">양양</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-lg-4 col-md-4 col-sm-12">
                                                <Modal show={isModal} onHide={handleClose}>
                                                    <Postcode
                                                        style={{ width: 320, height: 320 }}
                                                        jsOptions={{ animation: true, hideMapBtn: true }}
                                                        onSelected={(data) => {
                                                            let copiedObj = cloneObj(shopinfo);
                                                            copiedObj["zipcode"] = data.zonecode;
                                                            copiedObj["address1"] = data.address;
                                                            setShopinfo(copiedObj);
                                                            setModal(false);
                                                        }}
                                                    />
                                                </Modal>

                                                <div className="form-group">
                                                    <label className="form-control-label">우편번호</label>
                                                    <div className="input-group-append">
                                                        <input
                                                            name="zipcode"
                                                            type="text"
                                                            className="form-control"
                                                            maxLength="5"
                                                            value={shopinfo.zipcode || ""}
                                                            onChange={shopHandleChange}
                                                            data-type="int"
                                                        />
                                                        <button
                                                            className="btn btn-custom-search"
                                                            type="button"
                                                            onClick={() => setModal(true)}
                                                        >
                                                            <i className="icofont-search-2" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-lg-8 col-md-8 col-sm-12">
                                                <div className="form-group">
                                                    <label className="form-control-label">주소</label>
                                                    <input
                                                        name="address1"
                                                        type="text"
                                                        className="form-control"
                                                        max="50"
                                                        value={shopinfo.address1 || ""}
                                                        onChange={shopHandleChange}
                                                        placeholder="우편번호 찾기 버튼을 이용해 주세요."
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-lg-12 col-md-12 col-sm-12">
                                                <div className="form-group">
                                                    <label className="form-control-label">상세주소</label>
                                                    <input
                                                        id="address2"
                                                        name="address2"
                                                        type="text"
                                                        className="form-control"
                                                        max="50"
                                                        value={shopinfo.address2 || ""}
                                                        onChange={shopHandleChange}
                                                        placeholder="나머지 주소를 입력하세요."
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-lg-4 col-md-4 col-sm-12">
                                                <div className="form-group">
                                                    <label className="form-control-label">등록일자</label>
                                                    <input
                                                        name="registday"
                                                        type="text"
                                                        className="form-control"
                                                        readOnly={true}
                                                        value={shopinfo.registday || ""}
                                                        onChange={shopHandleChange}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-lg-4 col-md-4 col-sm-12">
                                                <div className="form-group">
                                                    <label className="form-control-label">상태</label>
                                                    <select
                                                        className="custom-select"
                                                        name="luse"
                                                        value={shopinfo.luse || "3"}
                                                        onChange={shopHandleChange}
                                                    >
                                                        <option value="1">사용</option>
                                                        <option value="3">중지</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row pt-10">
                                            <div className="col-12 text-center">
                                                <span
                                                    className="btn btn-main btn-icon btn-round-full"
                                                    onClick={fnShopSaveClick}
                                                >
                                                    저장
                                                </span>
                                                &nbsp;&nbsp;
                                                <span
                                                    className="btn btn-main-2 btn-icon btn-round-full"
                                                    onClick={fnShopDeleteClick}
                                                >
                                                    삭제
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="container">
                                <div className="row round-box">
                                    <div className="col-12">
                                        <div className="row">
                                            <div className="col-12 mb-30">
                                                <h5 className="sub-title">등록계정</h5>
                                            </div>

                                            <UserCard
                                                users={users}
                                                setUsers={setUsers}
                                                fnUserSaveClick={fnUserSaveClick}
                                                fnUserDeleteClick={fnUserDeleteClick}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <SubMenu id="admin" />
                    </div>
                </div>
            </section>
        </>
    );
}

export default MemberView;
